import { getStore as getMailStore } from '../../store/Store';
import { Module } from 'mini-common-schema';

/**
 * Tells if the given module is currently open
 */
export default function isInModule(moduleName: Module): boolean {
    return getMailStore().mailModule.selectedModule === moduleName;
}
